import "./Legal.module.css";
import Navigation from "@/reusable_sections/Header";
import Climate from "./sections/Climate";
import Facts from "./sections/Facts";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function LegalPage() {
  return <div>
      <Navigation />
      <Climate />
      <Facts />
      <Consultation />
      <Footer />
    </div>;
}